<template>
	<div id="pageRoot">

		<p class="textBase appearAnimationB" id="text01" style="z-index: 6">
			Lee los globos.<br><br>
			Dibuja los personajes y escribe quién<br>
			lo dijo.
		</p>

		<div class="text-box-a pageElement hover-animation-a" id="textBox01" style="z-index: 3; background-image: url(/pages/img/sordo/svgPage71TextBox01.svg); background-size:cover;">
			<p class="textBase" id="textBox01Text">
				¡Hop, Venancio!
			</p>
		</div>
		<!--BUTTONS----------------------------------------------------------------------------------------------------->		
		<!--BUTTONS--------------------------------------------------------------------------------------------------------->

		<!-- TEXTS ----------------------------------------------------------------------------------------------------->
		<!-- TEXTS ----------------------------------------------------------------------------------------------------->
		<div class="basicItem01" id="tagVenancio" style="z-index: 3; background-image: url(/pages/img/sordo/svgPage71TagShort.svg); background-size:cover;">
			<p class="textBase tagText">
				Venancio.
			</p>
		</div>
		<div class="basicItem01" id="tagLosChicos" style="z-index: 3; background-image: url(/pages/img/sordo/svgPage71TagShort.svg); background-size:cover;">
			<p class="textBase tagText">
				Los chicos.
			</p>
		</div>
		<div class="basicItem01" id="tagLosVecinos" style="z-index: 3; background-image: url(/pages/img/sordo/svgPage71TagLong.svg); background-size:cover;">
			<p class="textBase tagText">
				Los vecinos del barrio.
			</p>
		</div>
		<div class="basicItem01" id="tagDonFito" style="z-index: 3; background-image: url(/pages/img/sordo/svgPage71TagShort.svg); background-size:cover;">
			<p class="textBase tagText">
				Don Fito.
			</p>
		</div>

		<div class="text-box-a pageElement hover-animation-a" id="textBox02" style="z-index: 3;">
			<img src="/pages/img/sordo/svgPage71Cursiva01.svg" id="textBox02Cursiva01">
			<p class="textBase" id="textBox02Text">
				Estas letras te pueden ser útiles:
			</p>
			<img src="/pages/img/sordo/svgPage71Cursiva02.svg" id="textBox02Cursiva02">
		</div>

		<uploaded-image class="image01 pageElement" v-bind:page="$parent.page" v-bind:type="$parent.type" number=1></uploaded-image>
		<uploaded-image class="image02 pageElement" v-bind:page="$parent.page" v-bind:type="$parent.type" number=2></uploaded-image>

		<div style="position: absolute; margin-left: 2.5%; margin-top: 65%; z-index: 5">
			<image-upload v-bind:page="$parent.page" v-bind:type="$parent.type" number=1></image-upload>
		</div>
		<div style="position: absolute; margin-left: 52%; margin-top: 49%;">
			<image-upload v-bind:page="$parent.page" v-bind:type="$parent.type" number=2></image-upload>
		</div>

		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		<span id="fixedBackground" class="pageElement"></span>
		<span class="footer-page footer-write"></span>
		<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
	</div>
</template>
<style scoped>
#fixedBackground
{
position: absolute;
width: 973.21px;
height: 724px;
left: 19.29px;
top: 14px;
background-image: url(/pages/img/sordo/svgPage71Background.svg);
}
.tagText{
position: absolute;
left: 0px;
right: 0px;
top: 5px;
bottom: 0px;

font-size: 36px;
line-height: 49px;
text-align: center;

color: #FEFAFA;
}

#text01
{
position: absolute;
width: 420px;
height: 86px;
left: 56px;
top: 101px;

font-style: normal;
font-weight: normal;
font-size: 24px;
line-height: 25px;
}

#textBox01
{
position: absolute;
width: 338px;
height: 135.65px;
left: 154px;
top: 316px;
}
#textBox01Text
{
position: absolute;
width: 285px;
height: 49px;
left: 38px;
top: 20px;

font-size: 36px;
line-height: 49px;

color: #FBF8F8;
}

#textBox02
{
position: absolute;
width: 498px;
height: 222px;
left: 490px;
top: 547px;
}
#textBox02Text
{
position: absolute;
left: 7.8%;
right: 19.31%;
top: 37.79%;
bottom: 45.54%;

font-size: 24px;
line-height: 33px;

color: #ED1C24;
}
#textBox02Cursiva01
{
position: absolute;
width: 394.32px;
height: 38.91px;
left: 34px;
top: 37px;
}
#textBox02Cursiva02
{
position: absolute;
width: 273.44px;
height: 53.77px;
left: 47.71px;
top: 134.94px;
}
#tagVenancio{
position: absolute;
width: 217.67px;
height: 70.55px;
left: 523px;
top: 18px;
}
#tagDonFito{
position: absolute;
width: 217.67px;
height: 70.55px;
left: 526px;
top: 166px;
}
#tagLosChicos{
position: absolute;
width: 224px;
height: 70.55px;
left: 795px;
top: 18px;
}
#tagLosVecinos{
position: absolute;
width: 482px;
height: 70.55px;
left: 526px;
top: 92px;
}
.image01{
position: absolute;
width: 462px;
height: 305px;
left: 24px;
top: 429px;
}
.image02{
position: absolute;
width: 462px;
height: 305px;
left: 527px;
top: 268px;
}
</style>

<script>
	import ImageUpload from '../../../components/ImageUpload.vue'
	export default 
	{
		name: 'App',
		components:
		{
			ImageUpload
		}
	}
</script>